import styled from "styled-components";

const StyledTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 10px;
  text-shadow: 0px 4px 10px rgb(0 0 0 / 10%);
`;

const Title = ({ title }: { title: string }) => {
  return <StyledTitle>{title}</StyledTitle>;
};

export default Title;
